<template>
  <ion-page id="legacy-explorer-page">
    <ion-content>
      
    <div v-show="showTour">
      <Tour  :tour="tourInfo" :tourTrigger="tourTrigger" @tour-done="tourDone" />
    </div>

    <div id="the_board" :style="styleBoard">
      <CMChessboard :fen="fen" :validMoves="availableMoves" :orientation="orientation" 
                :boardSize="boardSize" @board-move="boardMove" />
    </div>

    <!-- For Slice Dice  -->
    <div id="the_slice_movelist" v-if="!showWinLoss" 
            :class="{ 'text-dark' : isDark,'text-light' : !isDark }" :style="styleMoveList">
      <LegacyMoveListSelector :resultsData="availableMoves" :eighty="eighty"
        :moveNumber="moveNumberValue"
        :moveListTrigger="availableMovesTrigger" 
        @checkbox-click="moveListCheckboxClick"  />
    </div>

    <div id="the_slice_chart" v-if="!showWinLoss" 
            :class="{ 'text-dark' : isDark,'text-light' : !isDark }" :style="styleChart">
      <SliceDiceAgChart :moveList="availableMoves" :moveNumber="moveNumberValue" 
            :showAdvantage="showWhiteAdvantage" :moveListTrigger="availableMovesTrigger" 
            :styleHeight="styleChartAgHeight"/> 
    </div>

    <!-- For WinLoss -->
    <div id="the_winloss_movelist" v-if="showWinLoss" 
                    :class="{ 'text-dark' : isDark,'text-light' : !isDark }"
                    :style="styleMoveList">
      <MoveList :resultsData="availableMoves" :eighty="eighty" :showScores="showScores" 
                :showCompare="showCompare"  
                @movelist-click="movelistClick"/>
    </div>

    <!-- main source -->
    <div  :style="styleMainLabel" v-bind:key="mainSource">
      <div v-if="mainSource == SOURCE_LICHESS">
          {{ t("Main") }}: Lichess: {{ mainBarMinValue }} {{ t("to") }} {{  mainBarMaxValue }}
      </div>
      <div v-show="mainSource == SOURCE_PLAYER">
        {{ t("Main") }}: {{ t("Your Games") }}
      </div>
      <div v-show="mainSource == SOURCE_MASTER">
        {{ t("Main") }}: {{ t("Master Games") }}
      </div>
    </div>

    <!-- compare source -->
    <div :style="styleCompareLabel" v-bind:key="compareSource">
      <div v-show="compareSource == SOURCE_LICHESS">
        {{ t("Compare") }}: Lichess: {{ compareSliderLabel }}: {{ compareBarMinValue }} {{ t("to") }} 
                    {{  compareBarMaxValue  }}
      </div>
      <div v-show="compareSource == SOURCE_PLAYER">
        {{ t("Compare") }}: {{ t("Your Games") }}
      </div>
      <div v-show="compareSource == SOURCE_MASTER">
        {{ t("Compare") }}: {{ t("Master Games") }}
      </div>
    </div>

    <!-- move number for bar chart -->
    <div v-if="!showWinLoss" :style="styleChartMoveNumber">
      <ion-list>
        <ion-item> 
          <!-- move number for bar chart -->
          <ion-button size="small" color="secondary" @click="toggleWhiteAdvantage()">
              {{ whiteAdvantageLabel }} @{{ t("Move") }} {{ moveNumberValue }} 
          </ion-button>
          <ion-range aria-label="Range with ticks" :ticks="true"    
                    :snaps="true" v-model="moveNumberValue"
                    :min="12" :max="21" :step="3" class="move_slider_style"
                    @ionChange="moveNumberChange">
          </ion-range>
        </ion-item>
      </ion-list>
    </div>

    <div id="the_movehistory" :style="styleMoveHistory" 
                  :class="{ 'text-dark' : isDark, 'text-light' : !isDark }">
      <MoveHistory :moveHistoryStack="moveHistoryStack" :trigger="moveHistoryTrigger" />
    </div>

    </ion-content>
    <Toolbar id="the_toolbar" :ignoreClicks="showTour"  
                :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
  </ion-page>
</template>

<script setup>

  import { IonItem, IonList, IonButton, IonRange,IonPage, IonContent, modalController } from '@ionic/vue';

  import ModalLegacyExplorer from '@/components/ModalLegacyExplorer.vue'
  import { t } from '@/composables/translateText.js'

  import LegacyMoveListSelector from '@/components/LegacyMoveListSelector.vue'
  import SliceDiceAgChart from '@/components/SliceDiceAgChart.vue'
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

  import CMChessboard from '@/components/CMChessboard.vue'
  import MoveList from '@/components/MoveList.vue'
  import Toolbar from '@/components/Toolbar.vue'
  import MoveHistory from '@/components/MoveHistory.vue'

  // import MultiRangeSlider from '@/components/MultiRangeSlider.vue'

  import { ref, watch } from 'vue'
  import { findToolbarElement, setToolbarElementDisabledFlag, setToolbarElementLabel} 
                from '@/composables/toolbarSupport.js'
  import { useGetData } from '@/composables/getData.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { onMounted, onBeforeUnmount } from 'vue'

  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } 
              from '@/composables/screenSize'
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import Tour from '@/components/Tour.vue'

  import { HeaderRowComp } from 'ag-grid-community';

  const TOOLBAR_FLIP = 0
  const TOOLBAR_BACK = 1
  const TOOLBAR_REWIND = 2
  const TOOLBAR_OPTIONS = 3
  const TOOLBAR_TOOGLE_SCORES_OR_WHITE_DIFF = 4

  const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"

  const MOVEHISTORY_FONTSIZE = 16
  const MOVEHISTORY_HEIGHT =  MOVEHISTORY_FONTSIZE * 1.2 * 2 + 4

  const emit = defineEmits(['boardMove'])

  const connectionStore = useConnectionStore()
  var explorerType = connectionStore.getProductOption
  //console.log("explorerType ",explorerType)

  const isDark = ref(connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)
  const tourTrigger = ref(0)
  const tourOption = connectionStore.getTourOption
  const showTour = ref((tourOption == "show"))

  var isSubscriber = (connectionStore.getIsSubscriber == 1)

  const toolbarElements = ref([
    { index : TOOLBAR_FLIP, label : t("Flip") ,disabled : false, collapse:true},
    { index : TOOLBAR_BACK, label : t("Back") , disabled : true, collapse:false},
    { index : TOOLBAR_REWIND, label : t("Rewind") , disabled : true, collapse:false},
    { index : TOOLBAR_OPTIONS, label : t("Options") , disabled : false, collapse:false}  ])

  const SHOW_EXPLORER = 0
  const showState = ref(SHOW_EXPLORER)

  const showWinLoss = ref(explorerType == "winloss")

  const SOURCE_NONE = 0
  const SOURCE_LICHESS = 2
  const SOURCE_PLAYER = 3
  const SOURCE_MASTER = 4
  const mainSliderLabel = ref("Rating")
  const compareSliderLabel = ref("Rating")

  const mainSource = ref(SOURCE_LICHESS)
  const compareSource = ref(SOURCE_NONE)
  const mainSourceString = ref("lichess")
  const compareSourceString = ref("none")

  var fenid4 = "147869767"
  var fenid8 = "1"

  var showUserMoveTree = false

  var whichBarChanged = "main"
  const mainBarMin = ref(800);
  const mainBarMax = ref(2500);
  const mainBarMinValue = ref(1000)
  const mainBarMaxValue = ref(2000)
  const mainBarStep = ref(50)

  const compareBarMin = ref(800);
  const compareBarMax = ref(2500);
  const compareBarMinValue = ref(1000)
  const compareBarMaxValue = ref(2000)
  const compareBarStep = ref(50)

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
  //console.log("**** explorer initial screensize", windowSizeRef.value)
  const boardSize = ref(100)

  
  const fen = ref(INITIAL_FEN)
  const eighty = ref(-2)
  const showScores = ref(true)
  const showCompare = ref(true)

  var playingWhite = 1
  var blankAppendTrigger = " "
  var orientation = ref("white")


  // what comes back from the server
  var mainMoves = []
  var compareMoves = []

  // merged result from the server grabs
  const availableMoves = ref([])

  const moveHistoryStack = ref([])
  const moveHistoryTrigger = ref(0)
  const moveHistoryString = ref("")
  const toolbarTrigger = ref(0)
  const gameCollectionTrigger = ref(0)

  // For Slice & Dice
  const moveNumberValue = ref(15)
  const availableMovesTrigger = ref(0)
  const showWhiteAdvantage = ref(false)
  const whiteAdvantageLabel = ref(t("All") + " ")

  const styleChartAgHeight = ref("height: 500px")
  var saveSelectedSans = []
  var selectedSansStack = []

  // End Slice & Dice

  // tour stuff
  const winlossTourInfo = {
    id : "opening_winloss",
    video : "",
    elements : [
      { id: "", title: t("Opening Explorer - Win/Loss"), text : t("With this opening explorer, you can evaluate win/loss percentages for various moves in the tree.<br><br>Chessvis gives you multiple ways to filter the games.")},
      { id: "", title: t("The Game Universe"), text : t("The Lichess 'rapid' games were used to build the tree.<br><br>Note: the tree is still being filled out. It has 200M games now and will have 600M in a couple of months. After that about 16M games will be added every month.")},
      { id: "", title: t("Focus on Rating brackets"), text : t("A detailed analysis of the game universe shows that it is important to focus on games around your rating.<br><br>Even a 50 point difference statistically outweighes even the best 'move' you can find.")},
      { id: "the_board", title: t("Making Moves Two Ways"), text : t("Moves can either be made on the board or by clicking on a move in the list")},
      { id: "the_winloss_movelist", title: t("The Move List"), text : t("The move choices are sorted in order of popularity. The moves above the 'blue' line make up 80% of the games. (This helps you identify the moves that matter.)<br><br>The stockfish engine score is shown at the right")},
      { id: "the_sliders", title: t("Set The Range"), text : t("The slider lets you set both the minimum and maximum ratings of the games to be included in the list.")},

      { id: "the_sliders", title: t("Subscriber Benefits"), text : t("Subscribers can compare two different groups.<br><br>They can also pull in their own games from Lichess and Chess.com for analysis and comparison.")},

      { id: "the_toolbar", title: t("Main (Game Source) - Toolbar"), text : t("The main win/loss list can come from the Lichess rapid games or the master game collection.<br><br>Subscribers can additionally select their own games.")},
      { id: "the_toolbar", title: t("Lichess Equal Rating - Toolbar"), text : t("Lichess games are brackets two ways:<br><br><b>Equal Rating</b> - only games where both the white and black players ratings fall within the same 50 point rating bracket. View this as 'head-to-head' competition.")},
      { id: "the_toolbar", title: t("Lichess Average Rating - Toolbar"), text : t("The other approach to Lichess game brackets is:<br><br><b>Average Rating</b> - the white and black player ratings are averaged and put into 100 point buckets.")},
      { id: "the_toolbar", title: t("Compare (Game Source) - Toolbar"), text : t("For subscribers, a second set of win/loss bars can be displayed for comparison.")},
    ]
  }

  const sliceDiceTourInfo = {
    id : "opening_slicedice",
    video : "",
    elements : [
      { id: "", title: t("Opening Explorer - Slice and Dice"), text : t("Why are we choosing the first moves of a game based on how games end 40 to 60 moves later?<br><br>Seems to me, an unfair burden to place on the beginning moves of the game.")},

      { id: "", title: t("Is There A Better Way?"), text : t("How about if we could see how games are going at the middle game?<br><br>I propose using the Stockfish engine score as a measure of how well games are going. The higher the score, the better white is doing. The lower the score, the better black is doing.")},
      { id: "", title: t("Seeing into the Middle Game"), text : t("Chessvis has calculated the Stockfish engine scores at moves 9, 12, 15, 18 and 21 for every game in the game collection.")},
      { id: "", title: t("The Game Collection"), text : t("The Lichess 'rapid' games were used to build the tree.<br><br>Note: the tree is still being filled out. It has 200M games now and will have 600M in a couple of months. After that about 16M games will be added every month.")},
      { id: "", title: t("That's A Lot of Scoring"), text : t("At 5 moves per game, that's a lot of scoring being done.<br><br>But that's necessary to get meaningful game counts outside of the most popular moves")},
      { id: "the_slice_movelist", title: t("The Move List"), text : t("The move choices are sorted in order of popularity. The moves above the 'blue' line make up 80% of the games.")},
      { id: "the_slice_movelist", title: t("Selecting Moves"), text : t("Clicking the move or checking the box, will add the move to the chart.<br><br>Next to the # of games is a weighted average of the Stockfish scores. Positive is good for white and negative is good for black.")},
      { id: "the_slice_movelist", title: t("Comparing Groups"), text : t("You can add a comparison group. That can be your games, master games or a different rating section of the Lichess games.")},
      { id: "the_sliders", title: t("Selecting the Move Number"), text : t("The important slider is the <b>Move Number</b>. That is the <i>future</i> move that will be used for the bar chart.<br><br>The available future moves are: 9, 12, 15, 18, and 21.")},
      { id: "the_slice_chart", title: t("The Graph"), text : t("The graph shows the distribution of the Stockfish engine scores for games where the checked move was made.<br><br>For example, if '1.e4' is checked and the slider is at move 15 then the graph shows how well players who played 'e4' are doing in their games at move 15.")},
      { id: "the_slice_chart", title: t("The Bars"), text : t("The bars show the percentage of games in each bucket. The buckets start on the left with black having already won the game by the future move number. Next to that is the percentage of games where black has a 'huge' advantage")},
      { id: "the_slice_chart", title: t("The Point Bars"), text : t("The next several bars break the stockfish engine scores into one point buckets.<br><br><i>(The 3 point bucket represents being up a bishop and the 1 point bucket represents being up by a pawn.)</i>")},
      { id: "the_slice_chart", title: t("The Middle and White's Bars"), text : t("The center bar shows the percentage of games that are about even.<br><br>The bars to the right are white's mirroring the black buckets from 1 point through already won games.")},
      { id: "the_toolbar", title: t("Main (Game Source) - Toolbar"), text : t("The main list can come from the Lichess rapid games, the master game collection or your own downloaded games.")},
      { id: "the_toolbar", title: t("Lichess Equal Rating - Toolbar"), text : t("Lichess games are brackets two ways:<br><br><b>Equal Rating</b> - only games where both the white and black players ratings fall within the same 50 point rating bracket. View this as 'head-to-head' competition.")},
      { id: "the_toolbar", title: t("Lichess Average Rating - Toolbar"), text : t("The other approach to Lichess game brackets is:<br><br><b>Average Rating</b> - the white and black player ratings are averaged and put into 100 point buckets.")},
      { id: "the_toolbar", title: t("Compare (Game Source) - Toolbar"), text : t("A second set of win/loss bars can be displayed for comparison.")},
      { id: "the_toolbar", title: t("Show White +  - Toolbar"), text : t("Obviously, for whatever color you're playing, you want moves where your bars are 'higher'. When you find yourself looking back and forth between the equivalent white and black bars, this button will show you the difference between the corresponding bars")},
      { id: "the_toolbar", title: t("More Show White +  - Toolbar"), text : t("In 'White+' mode, each bar shows the percentage advantage that white has over black.<br><br>For black then shorter bars are better.")},
    ]
  }

  const tourInfo = ref((showWinLoss.value) ? winlossTourInfo : sliceDiceTourInfo)

  const styleChart = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleMoveList = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleBoard = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleMoveHistory = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    "font-size" : MOVEHISTORY_FONTSIZE + "px",
    "text-align" : "left",
    "line-height" : "1em",
    "margin-top" : "0px",
    "margin-bottom" : "0px",
    "padding-top" : "0px",
    "padding-bottom" : "0px",
    "vertical-align": "top"
  })

  const styleMainLabel = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    "font-size" : MOVEHISTORY_FONTSIZE + "px",
    "line-height" : "1.2em",
    "text-align" : "center"
  })

  const styleCompareLabel = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    "font-size" : MOVEHISTORY_FONTSIZE + "px",
    "line-height" : "1.2em",
    "text-align" : "center"
  })

  const styleChartMoveNumber = ref({
    position : "absolute",
    "overflow-y" : "hidden",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    "font-size" : MOVEHISTORY_FONTSIZE + "px",
    "text-align" : "left",
    "line-height" : "1.2em"
  })

  doStartupCheck(false,afterStartupCallbackRoutine)

  function afterStartupCallbackRoutine(stuffChanged) {
    isSubscriber = (connectionStore.getIsSubscriber == 1)

    updateWidthHeights()
    getInitialUserInfo()
  }

  onMounted(() => {
    //console.log("explorer mounted")
    //getMoves()
  })

  function resetExplorerScreen() {
    // reset to beginning
    showState.value = SHOW_EXPLORER
    showWinLoss.value = (explorerType == "winloss")
    afterStartupCallbackRoutine(true)
  }

  watch(() => connectionStore.getProductOption, () => {
    //console.log("#################### explorer option changed ")
    explorerType = connectionStore.getProductOption
    //console.log("explorer type flag ",explorerType)

    resetExplorerScreen()
  })

  watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** Explorer -- window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** Explorer new window size",windowSizeRef.value)
    updateWidthHeights()
    menuTrigger.value++
  })

  function updateStyleObjects(boundaries) {
    boardSize.value = boundaries['board'].height

    styleBoard.value.height = boundaries['board'].height + "px"
    styleBoard.value.width = boundaries['board'].width + "px"
    styleBoard.value.top = boundaries['board'].top + "px"
    styleBoard.value.left = boundaries['board'].left + "px"

    styleMoveList.value.height = boundaries['moveList'].height + "px"
    styleMoveList.value.width = boundaries['moveList'].width + "px"
    styleMoveList.value.top = boundaries['moveList'].top + "px"
    styleMoveList.value.left = boundaries['moveList'].left + "px"

    styleMoveHistory.value.height = boundaries['history'].height + "px"
    styleMoveHistory.value.width = boundaries['history'].width + "px"
    styleMoveHistory.value.top = boundaries['history'].top + "px"
    styleMoveHistory.value.left = boundaries['history'].left + "px"

    styleMainLabel.value.height = boundaries['mainLabel'].height + "px"
    styleMainLabel.value.width = boundaries['mainLabel'].width + "px"
    styleMainLabel.value.top = boundaries['mainLabel'].top + "px"
    styleMainLabel.value.left = boundaries['mainLabel'].left + "px"

    styleCompareLabel.value.height = boundaries['compareLabel'].height + "px"
    styleCompareLabel.value.width = boundaries['compareLabel'].width + "px"
    styleCompareLabel.value.top = boundaries['compareLabel'].top + "px"
    styleCompareLabel.value.left = boundaries['compareLabel'].left + "px"

    styleChartMoveNumber.value.height = boundaries['chartMoveNumber'].height + "px"
    styleChartMoveNumber.value.width = boundaries['chartMoveNumber'].width + "px"
    styleChartMoveNumber.value.top = boundaries['chartMoveNumber'].top + "px"
    styleChartMoveNumber.value.left = boundaries['chartMoveNumber'].left + "px"

    styleChart.value.height = boundaries['chart'].height + "px"
    styleChart.value.width = boundaries['chart'].width + "px"
    styleChart.value.top = boundaries['chart'].top + "px"
    styleChart.value.left = boundaries['chart'].left + "px"


    if (showWinLoss.value == false) {
      styleChartAgHeight.value = "height: " + boundaries['chart'].height + "px"
    }
    /*
    if (showWinLoss.value == false) {

      styleMainSlider.value.width = (boundaries['sliders'].width * .4) + "px"
      styleMoveNumberSlider.value.width = (boundaries['sliders'].width * .2) + "px"
      styleCompareSlider.value.width = (boundaries['sliders'].width * .4) + "px"

      styleChart.value.height = boundaries['chart'].height + "px"
      styleChart.value.width = boundaries['chart'].width + "px"
      styleChart.value.top = boundaries['chart'].top + "px"
      styleChart.value.left = boundaries['chart'].left + "px"

      styleChartAgHeight.value = "height: " + boundaries['chart'].height + "px"
    }
    else {
      styleMainSlider.value.width = (boundaries['sliders'].width * .5) + "px"
      styleMoveNumberSlider.value.width = (0) + "px"
      styleCompareSlider.value.width = (boundaries['sliders'].width * .5) + "px"
 
    }
    */
    //console.log("**** boardsize ",boardSize.value)
  }


  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                      calculateLandscapeWidthHeights(availableSpace)
    
    updateStyleObjects(boundaries)
  }

  function calculatePortraitWidthHeights(availableSpace) {

    // Vertically -> Board, move history, (move list & chart side by side), sliders
    const availableSpaceForBoard = { width : availableSpace.width ,
                height : availableSpace.height / 2,
                isPortrait : true }

    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)
    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const historyPositionTop = boardPositionTop + boardHeight
    const historyPositionLeft = availableSpace.leftRightIndent
    const historyHeight = MOVEHISTORY_HEIGHT
    const historyWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const moveListPositionTop = historyPositionTop + historyHeight
    const moveListPositionLeft = availableSpace.leftRightIndent
    const moveListHeight = availableSpace.height - moveListPositionTop - MOVEHISTORY_HEIGHT
    const moveListWidth = (showWinLoss.value) ? historyWidth : historyWidth / 2

    const chartPositionTop = moveListPositionTop
    const chartPositionLeft = moveListPositionLeft + moveListWidth
    const chartHeight = moveListHeight
    const chartWidth = moveListWidth

    const mainLabelPositionTop = moveListPositionTop + moveListHeight
    const mainLabelPositionLeft = moveListPositionLeft
    const mainLabelHeight = MOVEHISTORY_HEIGHT / 2
    const mainLabelWidth = moveListWidth

    const compareLabelPositionTop = mainLabelPositionTop + mainLabelHeight
    const compareLabelPositionLeft = moveListPositionLeft
    const compareLabelHeight = MOVEHISTORY_HEIGHT / 2
    const compareLabelWidth = moveListWidth

    const moveNumberPositionTop = chartPositionTop + chartHeight
    const moveNumberPositionLeft = chartPositionLeft
    const moveNumberHeight = availableSpace.height - moveNumberPositionTop
    const moveNumberWidth = chartWidth

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop + availableSpace.topIndent
      },
      moveList : {
        width : moveListWidth,
        height : moveListHeight + availableSpace.leftIndent,
        left : moveListPositionLeft,
        top : moveListPositionTop + availableSpace.topIndent
      },
      history : {
        width : historyWidth,
        height : historyHeight,
        left : historyPositionLeft + availableSpace.leftIndent,
        top : historyPositionTop + availableSpace.topIndent
      },
      mainLabel : {
        width : mainLabelWidth,
        height : mainLabelHeight,
        left : mainLabelPositionLeft + availableSpace.leftIndent,
        top : mainLabelPositionTop + availableSpace.topIndent
      },
      compareLabel : {
        width : compareLabelWidth,
        height : compareLabelHeight,
        left : compareLabelPositionLeft + availableSpace.leftIndent,
        top : compareLabelPositionTop + availableSpace.topIndent
      },
      chartMoveNumber : {
        width : moveNumberWidth,
        height : moveNumberHeight,
        left : moveNumberPositionLeft + availableSpace.leftIndent,
        top : moveNumberPositionTop + availableSpace.topIndent
      },
      chart : {
        width : chartWidth,
        height : chartHeight,
        left : chartPositionLeft + availableSpace.leftIndent,
        top : chartPositionTop + availableSpace.topIndent
      }
    }
    //console.log("board and movelist dimensions",result)
    return (result)
    
  }

  function calculateLandscapeWidthHeights(availableSpace) {

    // reserve space for the instruction lines
    const availableSpaceForBoard = { width : availableSpace.width/2,
                height : availableSpace.height - MOVEHISTORY_HEIGHT,
                isPortrait : false }
    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const moveListPositionTop = 0
    const moveListPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    const moveListHeight = availableSpace.height - MOVEHISTORY_HEIGHT
    const moveListWidth = (showWinLoss.value) ? availableSpace.width - moveListPositionLeft : 350

    const mainLabelPositionTop = moveListPositionTop + moveListHeight
    const mainLabelPositionLeft = moveListPositionLeft
    const mainLabelHeight = MOVEHISTORY_HEIGHT / 2
    const mainLabelWidth = moveListWidth

    const compareLabelPositionTop = mainLabelPositionTop + mainLabelHeight
    const compareLabelPositionLeft = moveListPositionLeft
    const compareLabelHeight = MOVEHISTORY_HEIGHT / 2
    const compareLabelWidth = moveListWidth

    const chartPositionTop = 0
    const chartPositionLeft = moveListPositionLeft + moveListWidth
    const chartHeight = availableSpace.height - MOVEHISTORY_HEIGHT
    const chartWidth = availableSpace.width - chartPositionLeft

    const moveNumberPositionTop = chartPositionTop + chartHeight
    const moveNumberPositionLeft = chartPositionLeft
    const moveNumberHeight = availableSpace.height - moveNumberPositionTop
    const moveNumberWidth = chartWidth

    const historyPositionTop = boardPositionTop + boardHeight + 5
    const historyPositionLeft = availableSpace.leftRightIndent
    const historyHeight = availableSpace.height - historyPositionTop
    const historyWidth = boardWidth

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop + availableSpace.topIndent
      },
      moveList : {
        width : moveListWidth,
        height : moveListHeight,
        left : moveListPositionLeft + availableSpace.leftIndent,
        top : moveListPositionTop + availableSpace.topIndent
      },
      history : {
        width : historyWidth,
        height : historyHeight,
        left : historyPositionLeft + availableSpace.leftIndent,
        top : historyPositionTop + availableSpace.topIndent
      },
      mainLabel : {
        width : mainLabelWidth,
        height : mainLabelHeight,
        left : mainLabelPositionLeft + availableSpace.leftIndent,
        top : mainLabelPositionTop + availableSpace.topIndent
      },
      compareLabel : {
        width : compareLabelWidth,
        height : compareLabelHeight,
        left : compareLabelPositionLeft + availableSpace.leftIndent,
        top : compareLabelPositionTop + availableSpace.topIndent
      },
      chartMoveNumber : {
        width : moveNumberWidth,
        height : moveNumberHeight,
        left : moveNumberPositionLeft + availableSpace.leftIndent,
        top : moveNumberPositionTop + availableSpace.topIndent
      },
      chart : {
        width : chartWidth,
        height : chartHeight,
        left : chartPositionLeft + availableSpace.leftIndent,
        top : chartPositionTop + availableSpace.topIndent
      }
    }
    //console.log("board and movelist dimensions",result)
    return (result)
  }

  function moveNumberChange({ detail }) {
    //moveNumberValue.value = detail.value
    //console.log("move number change",detail,detail.value,moveNumberValue.value)
    availableMovesTrigger.value++
  }

  function toggleWhiteAdvantage() {
    showWhiteAdvantage.value = !showWhiteAdvantage.value
    whiteAdvantageLabel.value = (showWhiteAdvantage.value) ? t("White") + "+" : t("All") 
    availableMovesTrigger.value++
  }

  // For Slice & Dice
  function moveListCheckboxClick(item) {
    //console.log("move list checkbox",item)
    availableMoves.value[item.index].selected = item.flag
    availableMovesTrigger.value++
  }

  // End for Slice & Dice

  function incrementAppendTrigger() {
    if (blankAppendTrigger.length > 64)
      blankAppendTrigger = ""
    blankAppendTrigger += " "
  }

  function updateValues(e) {
    if (e.id == "main") {
      mainBarMinValue.value = e.minValue;
      mainBarMaxValue.value = e.maxValue;   
    }
    else {
      compareBarMinValue.value = e.minValue;
      compareBarMaxValue.value = e.maxValue; 
    }
  
    saveSelectedSans = []
    for (var i=0; i < availableMoves.value.length; i++)
      if (availableMoves.value[i].selected)
        saveSelectedSans.push(availableMoves.value[i].san)

    whichBarChanged = e.id

    processChange()
  }

  function setSliderValues(isMain) {
    if (isMain) {
      if (mainSource.value == SOURCE_LICHESS) {
        mainBarMin.value = 800
        mainBarStep.value = 50
        mainBarMax.value = 2500 
        if (mainBarMaxValue.value > mainBarMax.value)
          mainBarMaxValue.value = mainBarMax.value
        if (mainBarMinValue.value < mainBarMin.value)
          mainBarMinValue.value = mainBarMin.value
        //console.log("AVG main bar  issub",isSubscriber,mainBarMin.value,mainBarMax.value,mainBarStep.value)

      }
    }
    else {
      if (compareSource.value == SOURCE_LICHESS) {
        compareBarMin.value = 800
        compareBarStep.value = 50
        compareBarMax.value = 2500 
        if (compareBarMaxValue.value > compareBarMax.value)
          compareBarMaxValue.value = compareBarMax.value
        if (compareBarMinValue.value < compareBarMin.value)
          compareBarMinValue.value = compareBarMin.value
      }
    }
  }

  function sliderLabel(source) {
    //console.log("Set slider label ",source)
    switch (source) {
      case SOURCE_LICHESS :
        return ("Rating")
        break      
    }
    return ("")  
  }

  function tourDone() {
    showTour.value = false
  }

  // Options Modal
  const optionsModal = async () => {
    const modal = await modalController.create({
      component: ModalLegacyExplorer,
      componentProps: {
        mainMin : mainBarMinValue.value,
        mainMax : mainBarMaxValue.value,
        compareMin : compareBarMinValue.value,
        compareMax : compareBarMaxValue.value,
        mainSource : mainSourceString.value,
        compareSource : compareSourceString.value,
        showScores : showScores.value,
        isSubscriber : isSubscriber
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      //console.log("Explorer Options confirm",data)
      showScores.value = data.showScores
      mainBarMinValue.value = data.mainMin
      mainBarMaxValue.value = data.mainMax
      compareBarMinValue.value = data.compareMin
      compareBarMaxValue.value = data.compareMax
      mainSourceString.value = data.mainSource
      switch (data.mainSource) {
        case "master" :
          mainSource.value = SOURCE_MASTER
          mainSourceString.value = "master"
          break
        case "user" :
          mainSource.value = SOURCE_PLAYER
          mainSourceString.value = "user"
          break
        case "lichess" :
          mainSource.value = SOURCE_LICHESS
          mainSourceString.value = "lichess"
          break
      }
      switch (data.compareSource) {
        case "master" :
          compareSource.value = SOURCE_MASTER
          compareSourceString.value = "master"
          showCompare.value = true
          break
        case "user" :
          compareSource.value = SOURCE_PLAYER
          compareSourceString.value = "user"
          showCompare.value = true
          break
        case "lichess" :
          compareSource.value = SOURCE_LICHESS
          compareSourceString.value = "lichess"
          showCompare.value = true
          break
        case "none" :
          compareSource.value = SOURCE_NONE
          compareSourceString.value = "none"
          showCompare.value = false
          //zapNoCompare()
          break
      }
      GetRequiredMoves("both")
    }
  };

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };
  
  function toolbarClick(index) {
    //console.log("toolbar click",index)
    const element = findToolbarElement(toolbarElements.value,index)
    if (element.disabled)
      return

    switch (index) {
      case TOOLBAR_TOOGLE_SCORES_OR_WHITE_DIFF :
        if (showWinLoss.value) {
          showScores.value = !showScores.value
          setToolbarElementLabel(toolbarElements.value,index,
                      (showScores.value) ? "Hide Scores" : "Show Scores")
          toolbarTrigger.value++
        }
        else {
          showWhiteAdvantage.value = !showWhiteAdvantage.value
          setToolbarElementLabel(toolbarElements.value,index,
                      (showWhiteAdvantage.value) ? "Show Raw" : "Show White+")
          availableMovesTrigger.value++
          toolbarTrigger.value++
        }

        break
      case TOOLBAR_FLIP :
        //console.log("Flip")
        incrementAppendTrigger()
        playingWhite = 1 - playingWhite
        orientation.value = (playingWhite == 1) ? "white" + blankAppendTrigger : "black" + blankAppendTrigger

        // if showing user moves, need to rebuild on a flip since the 
        //    counts are dependent on the player's color
        if (mainSource.value == SOURCE_PLAYER)
          getUserMoves("main")
        else
        if (compareSource.value == SOURCE_PLAYER)
          getUserMoves("compare")
        break;
      case TOOLBAR_REWIND :
        fen.value = INITIAL_FEN + " "
        fenid8 = "1"
        fenid4 = "147869767"

        saveSelectedSans = (selectedSansStack.length) ? selectedSansStack[0] : []
        selectedSansStack = []

        //console.log("*** in back ",saveSelectedSans)
        selectedSansStack.pop()

        moveHistoryStack.value = []
        moveHistoryTrigger.value++
        GetRequiredMoves("both")  
        break
      case TOOLBAR_BACK :
        if (moveHistoryStack.value.length <= 1) {
          toolbarClick(TOOLBAR_REWIND)
        }
        else {

          saveSelectedSans = selectedSansStack[selectedSansStack.length - 1]
          //console.log("*** in back ",saveSelectedSans)
          selectedSansStack.pop()

          moveHistoryStack.value.pop()
          moveHistoryTrigger.value++
          fen.value = moveHistoryStack.value[moveHistoryStack.value.length - 1].fen
          fenid4 = moveHistoryStack.value[moveHistoryStack.value.length - 1].fenid4
          fenid8 = moveHistoryStack.value[moveHistoryStack.value.length - 1].fenid8

          //console.log("**** back -> ",fenid4,fenid8,fen.value)
          GetRequiredMoves("both")
        }
        break
      case TOOLBAR_OPTIONS :
        optionsModal()
        break
    }

  }

  // called with "both" if both main & compare need refreshing
  function GetRequiredMoves(source) {

    //console.log("in get required moves   source->",source)
    if (source == "both" && compareSource.value == SOURCE_NONE)
      source = "main"
      
    const useSource = (source == "both" || source == "main") ? mainSource.value : compareSource.value
    const useMin = (source == "both" || source == "main") ? mainBarMinValue.value : compareBarMinValue.value
    const useMax = (source == "both" || source == "main") ? mainBarMaxValue.value : compareBarMaxValue.value

    //console.log("in getRequiredMOves  source useSource",source,useSource)
    if (useSource == SOURCE_LICHESS)
      getLichessMoves(source,useMin,useMax)
    else
    if (useSource == SOURCE_PLAYER)
      getUserMoves(source)
    else
    if (useSource == SOURCE_MASTER)
      getMasterMoves(source)
  }

  function movelistClick(arrayIndex) {
   const san = availableMoves.value[arrayIndex].san
    
    if (san == "total")
      return

    fen.value = availableMoves.value[arrayIndex].fen
    fenid4 = availableMoves.value[arrayIndex].fenid4
    fenid8 = availableMoves.value[arrayIndex].fenid8
 
    // save current move's sans before getting next ply
    saveSelectedSans = []
    for (var i=0; i < availableMoves.value.length; i++)
      if (availableMoves.value[i].selected)
        saveSelectedSans.push(availableMoves.value[i].san)
    selectedSansStack.push(saveSelectedSans)

    //console.log("selected sans before next move",saveSelectedSans)
    saveSelectedSans = []

    const oneMove = {fen : fen.value, fenid4 : fenid4, fenid8: fenid8, san : san }
    moveHistoryStack.value.push(oneMove)
    moveHistoryTrigger.value++

    GetRequiredMoves("both")
  }

  function boardMove(arrayIndex,from,to) {
    movelistClick(arrayIndex)
  }

  // merge the main & compare moves
  function buildAvailableMoves() {

    availableMoves.value = []

    //console.log("in build counts",mainMoves.length,compareMoves.length)

    // main moves all come first
    for (var mainIndex=0; mainIndex < mainMoves.length; mainIndex++) {
      const oneMainMove = mainMoves[mainIndex]

      // is there a compare to go with this one?
      var foundCompareMatch = false
      for (var compareIndex = 0; compareIndex < compareMoves.length; compareIndex++) {
        if (compareMoves[compareIndex].san == oneMainMove.san) {
          const oneCompareMove = compareMoves[compareIndex]

          oneMainMove.whiteCompare = oneCompareMove.white
          oneMainMove.blackCompare = oneCompareMove.black
          oneMainMove.drawCompare = oneCompareMove.draw
          oneMainMove.totalCompare = oneCompareMove.total

          // Slice & Dice
          oneMainMove.weightedScoresCompare = oneCompareMove.weightedScores
          oneMainMove.movesCompare = oneCompareMove.moves

          foundCompareMatch = true
          break
        }
      }

      if (foundCompareMatch == false) {
          oneMainMove.whiteCompare = "0"
          oneMainMove.blackCompare = "0"
          oneMainMove.drawCompare = "0"
          oneMainMove.totalCompare = "-"
          oneMainMove.weightedScoresCompare = []
          oneMainMove.movesCompare = []

      }
      availableMoves.value.push(oneMainMove)
    }

    // any compare moves that aren't in main, come last
    for (var compareIndex = 0; compareIndex < compareMoves.length; compareIndex++) {
      const oneCompareMove = compareMoves[compareIndex]

      // is this compare move not on the main list?
      var match = false
      for (var mainIndex=0; mainIndex < mainMoves.length; mainIndex++) {
        if (mainMoves[mainIndex].san == oneCompareMove.san) {
          match = true
          break
        }
      }
      // the compare is unique, add it to available moves
      if (match == false) {
          const oneMove = {
            index: availableMoves.value.length, 
            fenid4: oneCompareMove.fenid4, 
            fenid8: oneCompareMove.fenid8,
            white : "0", black : "0", draw : "0",
            from : oneCompareMove.from, to: oneCompareMove.to,
            san : oneCompareMove.san, total : "-", 
            score : oneCompareMove.score, fen : oneCompareMove.fen,

            selected : false,
            weightedScores : [],
            moves : [],
      
            whiteCompare : oneCompareMove.white,
            blackCompare : oneCompareMove.black,
            drawCompare : oneCompareMove.draw,
            totalCompare : oneCompareMove.total,
            weightedScoresCompare : oneCompareMove.weightedScores,
            movesCompare : oneCompareMove.moves

          }
          availableMoves.value.push(oneMove)
      }
    }
    //console.log("available moves",availableMoves.value)
    availableMovesTrigger.value++
  }

  function processJsonResponse (json) {
    //console.log("*** in process json callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
    //console.log("*** process Fens ***")
    //console.log(json)
    const isMain = json['is_main']

    //console.log("*** process moves for -> ",isMain)
    const whiteString = json['white']
    const blackString = json['black']
    const drawString = json['draw']
    const whites = whiteString.split("\t")
    const blacks = blackString.split("\t")
    const draws = drawString.split("\t")
    const sans = json['san'].split("\t")
    const pretty_game_counts = json['pretty'].split("\t")
    //const scores = json['score'].split("\t")
    const fens = json['fen'].split("\t")
    const fenid4s = json['fenid4'].split("\t")
    const fenid8s = json['fenid8'].split("\t")

    const engineScores = json['stockfish'].split("\t")

    const froms = json['from'].split("\t")
    const tos = json['to'].split("\t")

    if (isMain == "main" || isMain == "both")
      eighty.value = json['eighty']
    const count = json['count']
  
    var scores = []
    const weights = [ -6, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 6]

    if (showWinLoss.value == false)
      scores = json['scores'].split("\t")

    if (isMain == "main" || isMain == "both")
      mainMoves = []
    else
      compareMoves = []

    for (var i=0; i < count; i++) {
      const whiteNumber = Number(whites[i])
      const blackNumber = Number(blacks[i])
      const drawNumber = Number(draws[i])
      const totalNumber = whiteNumber + blackNumber + drawNumber

      const whitePercent = (totalNumber > 0) ? whiteNumber * 100 / totalNumber : 0
      const blackPercent = (totalNumber > 0) ? blackNumber * 100 / totalNumber : 0
      const drawPercent = (totalNumber > 0) ? drawNumber * 100 / totalNumber : 0
      const whitePercentString = whitePercent.toFixed(1)
      const blackPercentString = blackPercent.toFixed(1)
      const drawPercentString = drawPercent.toFixed(0)

      // Slice & Dice
      var moves = []
      var weightedScores = []
      var isSelected = false

      if (showWinLoss.value == false) {
        const moveScores = scores[i].split(",")
        for (var moveIndex = 0; moveIndex < 5; moveIndex++) {
          const offset = moveIndex * 15
          var weight = 0
          var percentages = []
          for (var percentIndex = 0; percentIndex < 15; percentIndex++) {
            const oneNumber = Number(moveScores[offset + percentIndex])
            weight += oneNumber * weights[percentIndex]
            percentages.push(oneNumber)
          }
          moves.push(percentages)
          weightedScores.push((weight/100).toFixed(2))
        }
      }

      // if there is a saved selected list, use it, otherwise use the first two
      if (saveSelectedSans.length) {
        var isSelected = false
        for (var j=0; j < saveSelectedSans.length; j++)
          if (sans[i] == saveSelectedSans[j]) {
            isSelected = true
            break
          }
      }
      else
        isSelected = (isMain == "main") ? (i < 2) : (i == 0)

      const oneMove = { index: i, fenid4: fenid4s[i], fenid8: fenid8s[i],
                        white : whitePercentString, black : blackPercentString, 
                        draw : drawPercentString,
                        whiteCompare : "0", blackCompare: "0", drawCompare: "0",
                        totalCompare : "-",

                        // Slice & Dice
                        weightedScores : weightedScores,
                        selected : isSelected,
                        moves : moves,

                        from : froms[i], to: tos[i],
                        san : sans[i], total : pretty_game_counts[i], 
                        score : engineScores[i], fen : fens[i]}
          
      if (isMain == "main" || isMain == "both")
        mainMoves.push(oneMove)
      else
        compareMoves.push(oneMove)
    }

    // if both columns need loading then getting the compare
    if (isMain == "both")
      GetRequiredMoves("compare")
    else
      buildAvailableMoves()

    // update the toolbar
    const ply = moveHistoryStack.value.length
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,(ply >= 1) ? false : true)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,(ply >= 1) ? false : true)
    toolbarTrigger.value++
    
  }

  function debounce(callback, interval=500) {
    let debounceTimeoutId;

    return function(...args) {
      clearTimeout(debounceTimeoutId);
      debounceTimeoutId = setTimeout(() => callback.apply(this, args), interval);
    };
  }

  function getLichessMoves(isMain,barMin,barMax) {
    var source = "equal"

    var formData = {
      fenid4 : fenid4,
      fenid8 : fenid8,
      white_to_move : 1 - (moveHistoryStack.value.length % 2),
      playing_white : (orientation.value == "white") ? "1" : "0",
      source : source,
      future : (showWinLoss.value) ? "no" : "yes",
      is_main : isMain,
      minr : barMin,
      maxr : barMax
    }

    // zap waiting for next move values
    availableMoves.value = []
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,true)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,true)

    if (isMain == "main" || isMain == "both")
      eighty.value = -2

    //console.log("before post for tree statistics -> ",formData)

    useGetData("chessvis_legacy_tree_statistics.php", formData, processJsonResponse)
  }

  function getMasterMoves(isMain) {
  
    var formData = {
      fenid4 : fenid4,
      fenid8 : fenid8,
      white_to_move : 1 - (moveHistoryStack.value.length % 2),
      playing_white : (orientation.value == "white") ? "1" : "0",
      source : "master",
      future : (showWinLoss.value) ? "no" : "yes",
      is_main : isMain,
      minr : 0,
      maxr : 0
    }

    // zap waiting for next move values
    availableMoves.value = []
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,true)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,true)

    if (isMain == "main" || isMain == "both")
      eighty.value = -2
    //console.log("before post -> ",fenid)

    useGetData("chessvis_legacy_tree_statistics.php", formData, processJsonResponse)
  }

  function getUserMoves(isMain) {
    var formData = {
      fenid4 : fenid4, 
      fenid8 : fenid8,
      player_white : playingWhite,
      white_to_move : 1 - (moveHistoryStack.value.length % 2),
      is_main : isMain,
      future : (showWinLoss.value) ? "no" : "yes",
    }

    // zap waiting for next move values
    availableMoves.value = []

    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,false)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,false)
    toolbarTrigger.value++

    if (isMain == "main" || isMain == "both")
      eighty.value = -2
    //console.log("before post to get USER moves-> ",formData)

    useGetData("chessvis_legacy_user_slice_dice.php", formData, processJsonResponse)
  }

  function processInitialJsonResponse (json) {
    //console.log(" in initial json callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    const program = (showWinLoss.value) ? "winloss_" : "slicedice_"

    const mainSourceName = json[program + 'main']
    const compareSourceName = json[program + 'compare']

    switch (mainSourceName) {
      case "avg" :
      case "equal" :
        mainSource.value = SOURCE_LICHESS
        mainSourceString.value = "lichess"
        mainBarMaxValue.value = Number(json[program + 'main_max'])
        mainBarMinValue.value = Number(json[program + 'main_min'])
        mainSliderLabel.value = sliderLabel(mainSliderLabel.value)
        setSliderValues(true)
        break
      case "master" :
        mainSourceString.value = "master"
        mainSource.value = SOURCE_MASTER
        break
      case "user" :
        mainSourceString.value = "user"
        mainSource.value = (isSubscriber) ? SOURCE_PLAYER : SOURCE_LICHESS
        break
      default :
        mainSourceString.value = "lichess"
        mainSource.value = SOURCE_LICHESS
        break
    }

    switch (compareSourceName) {
      case "avg" :
      case "equal" :
        compareSource.value = SOURCE_LICHESS
        compareSourceString.value = "lichess"
        compareBarMaxValue.value = Number(json[program + 'compare_max'])
        compareBarMinValue.value = Number(json[program + 'compare_min'])
        compareSliderLabel.value = sliderLabel(compareSource.value)
        setSliderValues(false)
        break
      case "master" :
        compareSourceString.value = "master"
        compareSource.value = SOURCE_MASTER
        break
      case "user" :
        compareSourceString.value = "user"
        if (isSubscriber) {
          compareSource.value = SOURCE_PLAYER
        }
        else {
          compareSource.value = SOURCE_NONE
          showCompare.value = false
        }
        break
      case "none" :
        compareSourceString.value = "none"
        compareSource.value = SOURCE_NONE
        showCompare.value = false
        break
      default :
        compareSourceString.value = "none"
        compareSource.value = SOURCE_NONE
        showCompare.value = false
        break
    }

    GetRequiredMoves( (compareSource.value == SOURCE_NONE) ? "main" : "both")
    menuTrigger.value++
  }

  function getInitialUserInfo() {

    var formData = {
    }

    useGetData("chessvis_legacy_user_explorer_tree_info.php", formData, processInitialJsonResponse)
  }


  function processZapNoCompareJsonResponse(json) {
    //console.log(" in no compare callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
    compareMoves = []
    buildAvailableMoves()
  }

  function zapNoCompare() {
    var formData = {
      future : "no"
    }
    //console.log("before post -> ",formData)

    useGetData("chessvis_legacy_explorer_no_compare.php", formData, processZapNoCompareJsonResponse)
  }
</script>

<style scoped>

</style>